import { FunctionComponent } from "react";

import { Stack } from "@bps/fluent-ui";
import { UserStatus } from "@libs/gateways/core/CoreGateway.dtos.ts";
import { LocationsSelectField } from "@modules/practice/screens/shared-components/location/LocationsSelectField.tsx";
import { CalendarEvent } from "@stores/booking/models/CalendarEvent.ts";
import { useStores } from "@stores/hooks/useStores.ts";
import { DatePickerField } from "@ui-components/form/DatePickerField.tsx";
import { Fieldset } from "@ui-components/form/Fieldset/Fieldset.tsx";
import { SpinNumberInputField } from "@ui-components/form/SpinNumberInputField.tsx";
import { TextInputField } from "@ui-components/form/TextInputField.tsx";
import { TimePickerField } from "@ui-components/form/TimePickerField.tsx";
import { ContactPickerField } from "@ui-components/pickers/contact-picker/ContactPickerField.tsx";
import { BookableUserPickerField } from "@ui-components/pickers/user-picker/BookableUserPickerField.tsx";

import { Booked } from "../../shared-components/Booked.tsx";
import { CreateTemporaryReservation } from "./CreateTemporaryReservation.tsx";
import { nameOf } from "./MeetingFormValues.ts";

export const MeetingFormFields: FunctionComponent = () => {
  const { booking, core } = useStores();
  const calendarEventId: string | undefined = booking.ui.currentAppointment?.id;

  const calendarEvent: CalendarEvent | undefined = calendarEventId
    ? booking.calendarEventsMap.get(calendarEventId)
    : undefined;

  const bookedByUser = calendarEvent && calendarEvent.bookedByUser;
  const bookedDate = calendarEvent && calendarEvent.startDateTime;
  return (
    <>
      <Stack tokens={{ childrenGap: 8 }}>
        <ContactPickerField name={nameOf("contactId")} label="Contact" />

        <BookableUserPickerField
          name={nameOf("providerId")}
          label="Provider"
          filter={{
            statusCodes: [UserStatus.Active],
            showOnCalendar: true
          }}
          required
          getTextFromItem={item => item.text!}
          iconName="Search"
        />

        {core.hasMultipleActiveLocations && (
          <LocationsSelectField
            name={nameOf("orgUnitId")}
            label="Location"
            required
          />
        )}

        <Fieldset horizontal horizontalAlign="start">
          <DatePickerField label="Date" name={nameOf("startDate")} />
          <TimePickerField
            label="Time"
            suggestionInterval={15}
            name={nameOf("startTime")}
          />
          <SpinNumberInputField
            required
            label="Duration"
            name={nameOf("duration")}
            min={0}
            step={15}
            suffix="mins"
            fieldItemStyles={{
              itemWrapper: { alignItems: "baseline" },
              item: { flexGrow: 0 }
            }}
            // SpinNumberInput component has a min width of 86
            styles={{ root: { width: 90 } }}
          />
        </Fieldset>

        <TextInputField
          multiline={true}
          label="Comments"
          name={nameOf("comments")}
        />
      </Stack>
      <Booked bookedByUser={bookedByUser} bookedDate={bookedDate} />
      <CreateTemporaryReservation />
    </>
  );
};
